import React from 'react';
import FeedbackContainer from './FeedbackContainer';
import { connect } from 'react-redux';

class FeedbackStateDataWait extends React.Component{
    render(){
        return(
            this.props.feedbackType ? <FeedbackContainer/> : ''
        )
    }
}

const mapStateToProps = state => {
    return {
        feedbackType : state.feedbackData.feedbackType
    }
}

export default connect(mapStateToProps)(FeedbackStateDataWait);